/*
upperLimit: maximum possible value (inclusive) of the random number.
returnCount: number of random numbers in the range(0, upperLimit) required.
*/
export function randomColour () {
  let colour = {
    r: 0,
    g: 0,
    b: 0
  }

  for (let component in colour) {
    colour[component] = randomNumber(240)
  }

  return colour
}

function randomNumber (upperLimit) {
  return Math.floor(Math.random() * upperLimit) + 1
}



// WEBPACK FOOTER //
// ./src/Services/colours.js